export default __webpack_public_path__ + "8fead86b0fd54dd2278c25cb43ed0cbf.mp3";